import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import store from '@/store'; // import axios from 'axios'
// const axios = require('axios')
// import qs from 'qs'

var qs = require('qs');

import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util'; // 创建一个错误

function errorCreate(msg) {
  var error = new Error(msg);
  errorLog(error);
  throw error;
}

function logout() {
  // 登出
  store.dispatch('u8sdk/account/logout', {
    confirm: false
  });
}

function showNoPermission() {
  // 无操作权限
  MessageBox.alert('Hi，您好， 您当前无该操作权限', '操作提示', {
    confirmButtonText: '确定',
    callback: function callback(action) {
      console.log('cancel no permission tips');
    }
  });
} // 记录和显示错误


function errorLog(error) {
  // 添加到日志
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>');
    console.log(error);
  } // 显示提示


  Message({
    message: error.message,
    type: 'error',
    duration: 3 * 1000
  });
} // 允许cookie携带， 要不然不同请求session会不相同


axios.defaults.withCredentials = true; // 创建一个 axios 实例

var service = axios.create({
  baseURL: util.getApiUrl(),
  timeout: 10000,
  transformRequest: [function (data) {
    if (data instanceof FormData) {
      return data;
    } else {
      return qs.stringify(_objectSpread({}, data));
    }
  }]
}); //service.defaults.headers.get['content-type'] = 'application/json;charset=UTF-8'
// 请求拦截器

service.interceptors.request.use(function (config) {
  // 在请求发送之前做一些处理
  var uid = util.cookies.get('uuid');
  var token = util.cookies.get('token');
  var username = util.cookies.get('username'); // 让每个请求携带token-- ['U-Token']为自定义key 请根据实际情况自行修改

  config.headers['U-Uid'] = uid;
  config.headers['U-Token'] = token;
  config.headers['U-UserName'] = username;
  return config;
}, function (error) {
  // 发送失败
  console.log(error);
  return Promise.reject(error);
}); // 响应拦截器

service.interceptors.response.use(function (response) {
  // dataAxios 是 axios 返回数据中的 data
  var dataAxios = response.data; // 这个状态码是和后端约定的

  var code = dataAxios.code; // 根据 code 进行判断

  if (code === undefined) {
    // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
    return dataAxios;
  } else {
    // 有 code 代表这是一个后端接口 可以进行进一步的判断
    switch (code) {
      case 0:
        // [ 示例 ] code === 0 代表没有错误
        return dataAxios.data;

      case 2:
        // 重新登录
        logout();
        break;

      case 3:
        // 无操作权限
        showNoPermission();
        break;

      default:
        // 不是正确的 code
        errorCreate("".concat(dataAxios.msg));
        break;
    }
  }
}, function (error) {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '请求错误';
        break;

      case 401:
        error.message = '未授权，请登录';
        break;

      case 403:
        error.message = '拒绝访问';
        break;

      case 404:
        error.message = "\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ".concat(error.response.config.url);
        break;

      case 408:
        error.message = '请求超时';
        break;

      case 500:
        error.message = '服务器内部错误';
        break;

      case 501:
        error.message = '服务未实现';
        break;

      case 502:
        error.message = '网关错误';
        break;

      case 503:
        error.message = '服务不可用';
        break;

      case 504:
        error.message = '网关超时';
        break;

      case 505:
        error.message = 'HTTP版本不受支持';
        break;

      default:
        break;
    }
  }

  errorLog(error);
  return Promise.reject(error);
});
export default service;